import React from "react";
import cn from "classnames";
import styles from "./OpcoDetails.module.sass";
import Card from "../../../../components/Card";

const OpcoDetails = ({ className, comptabilityData }) => {
  const contractInfo = comptabilityData?.contractInfo || {};

  return (
    <Card
      className={cn(styles.card, className)}
      title="Opco"
      classTitle="title-yellow"
    >
      <div className={styles.overview}>
        <div className={styles.infoList}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>N° Interne</span>
            <span className={styles.infoValue}>{contractInfo?.numero_interne || "Non renseigné"}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>N° DECA</span>
            <span className={styles.infoValue}>{contractInfo?.numero_deca || "Non renseigné"}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>N° Externe</span>
            <span className={styles.infoValue}>{contractInfo?.numero_externe || "Non renseigné"}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Statut OPCO</span>
            <span className={styles.infoValue}>{contractInfo?.opco_status || "Non renseigné"}</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default OpcoDetails;
